import { z } from 'zod';
import { GameServiceConfigScheme } from '../gameService';

/**
 * Scheme for CasinoConfig (extends from GameServiceConfigScheme)
 */
const CasinoConfigScheme = GameServiceConfigScheme.extend({
  pageGeneralRouteName: z.string().default(''),
  newRelicLogActions: z
    .object({
      GAME_CLICK: z.string().default(''),
      VIEW_ALL: z.string().default('')
    })
    .default({}),
  isOnlyVerifiedCanPlay: z.boolean().default(false)
})
  .passthrough()
  .default({});

/**
 * Scheme for CasinoSettings
 */
export const CasinoSettingsScheme = z
  .object({
    casino: CasinoConfigScheme,
    casinoLive: CasinoConfigScheme,
    instantGames: CasinoConfigScheme
  })
  .passthrough()
  .default({});

export type CasinoConfig = z.infer<typeof CasinoConfigScheme>;
